require('angular')
SessionService = require('./session-service')

angular.module 'gnp-session', []
  .factory 'SessionService', SessionService




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/session/session-module.coffee